import { Error, Fade } from '../../components/common'

export default () => (
  <Fade>
    <div className="container" style={{ marginTop: '50px' }}>
      <div className="row">
        <div className="col-xs-12">
          <Error title="Access Denied" message="You do not have access." />
        </div>
      </div>
    </div>
  </Fade>
)
